

























































































































import { Vue, Component, Ref, Mixins } from "vue-property-decorator";

import ProgressScore from "@/components/ReportResultTable/Progress.vue";

import ReportsMixin from "./Reports.mixin";

import {
  IIndividualReport,
  ILevelReport,
  ILevelReportUser
} from "@/models/interfaces/report-generator";
import { IVuexState } from "@/models/interfaces/store";
import { clone } from "ramda";

@Component({
  components: {
    ProgressScore
  }
})
export default class LevelReport extends Mixins<
  ReportsMixin<IIndividualReport>
>(ReportsMixin) {
  private get tableColumns() {
    return [
      {
        value: "unit",
        label: "Unit"
      },
      {
        value: "name",
        label: "Lesson name"
      },
      {
        value: "percentage0",
        label: "Activity 1",
        custom: true,
        name: "activity1"
      },
      {
        value: "percentage1",
        label: "Activity 2",
        custom: true,
        name: "activity2"
      },
      {
        value: "percentage2",
        label: "Activity 3",
        custom: true,
        name: "activity3"
      },
      {
        value: "percentage3",
        label: "Activity 4",
        custom: true,
        name: "activity4"
      },
      {
        value: "eye",
        label: "",
        name: "eye",
        custom: true
      }
    ];
  }

  private get computedData() {
    const data = this.reportData?.lessons || {};

    const reportData = Object.entries(data).map(item => ({
      lessonId: item[0],
      ...item[1]
    }));

    return reportData.map(({ percentages, ...other }) => {
      const percentagesObj = {};

      percentages.forEach((p, index) => {
        percentagesObj[`percentage${index}`] = p;
      });

      return {
        ...other,
        ...percentagesObj
      };
    });
  }

  private generateCsvFile() {
    const headers = {
      unit: "Unit",
      name: "Lesson name",
      percentage0: "Activity 1",
      percentage1: "Activity 2",
      percentage2: "Activity 3",
      percentage3: "Activity 4"
    };

    const data = this.computedData.map(({ lessonId, unitId, ...other }) => ({
      ...other
    }));

    this.exportCSVFile(headers, data, this.title);
  }
}
